var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMute = function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mute_svg__a)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7 13.05h-.468V10.95H7.7v2.102Z",
    fill: "currentColor",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.142 13.742V10.29L12.66 8v8l-3.517-2.258Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 0.334,
    d: "m15.036 10.59 2.657 2.638-.235.237-2.657-2.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 0.334,
    d: "m17.458 10.59-2.657 2.638.235.237 2.658-2.637z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mute_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMute;